import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconClock = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M30.784 3.783c-4.47.169-8.835 1.425-12.832 3.692-2.277 1.291-4.887 3.372-6.68 5.327-2.833 3.086-4.927 6.663-6.177 10.549a30.5 30.5 0 0 0-1.192 5.583c-.174 1.538-.174 4.594 0 6.132.375 3.3 1.28 6.413 2.714 9.328.693 1.41.994 1.933 1.869 3.254a28 28 0 0 0 7.866 7.864c1.319.876 1.84 1.176 3.259 1.874 4.236 2.083 8.658 3.003 13.597 2.827a27.5 27.5 0 0 0 11.181-2.828c1.42-.697 1.94-.997 3.259-1.873a27.9 27.9 0 0 0 7.865-7.864c.875-1.32 1.175-1.84 1.873-3.259 2.083-4.236 3.003-8.658 2.827-13.597a27.5 27.5 0 0 0-2.828-11.181c-.697-1.418-.997-1.94-1.872-3.259a27.9 27.9 0 0 0-7.865-7.864c-1.319-.876-1.84-1.176-3.259-1.874-3.455-1.7-7.345-2.698-10.949-2.81a53 53 0 0 1-1.28-.05 26 26 0 0 0-1.376.03m.128 4.005c-3.344.151-6.537.97-9.568 2.454-2.527 1.237-4.45 2.613-6.469 4.633-2.856 2.856-4.78 6.034-6.03 9.958-.72 2.267-1.06 4.574-1.058 7.199.004 3.849.775 7.186 2.456 10.624.653 1.337 1.21 2.28 1.977 3.354 3.649 5.098 8.967 8.549 15.044 9.76 3.055.61 6.417.61 9.472 0 5.273-1.051 10.019-3.811 13.58-7.898 5.66-6.495 7.414-15.606 4.582-23.804-1.6-4.633-4.547-8.637-8.53-11.59-4.39-3.256-9.942-4.94-15.456-4.69m.623 12.886c-.406.102-.72.297-1.026.637-.515.573-.491.28-.495 6.035l-.004 5.105.167.37c.149.334.79.995 6.258 6.46 6.804 6.799 6.367 6.414 7.277 6.414.81 0 1.43-.381 1.789-1.101.166-.333.195-.462.194-.876 0-.915.346-.518-6.017-6.886l-5.692-5.696-.017-4.544-.017-4.544-.15-.288c-.209-.404-.615-.801-.977-.957s-.95-.215-1.29-.13" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconClock.displayName = 'IconClock';